module.exports = __webpack_public_path__ + "img/f7d9601.jpg";